'use client';

import React from 'react';

export default function ExpiredQRState({ message }: { message?: string }) {
  return (
    <div className="fade-in flex flex-col gap-5 text-center">
      {/* Warning icon */}
      <div className="card-phone p-8 flex flex-col items-center gap-4">
        <div className="w-20 h-20 rounded-full bg-amber-50 border-2 border-amber-200 flex items-center justify-center">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#c05a00" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground mb-2">QR Code Expired</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {message ?? 'This QR code has expired. Please scan the current QR code displayed at The English Island.'}
          </p>
        </div>

        <div className="w-full bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
          <p className="text-amber-800 text-sm font-medium">
            QR codes rotate every 30 seconds to prevent screenshot reuse.
          </p>
        </div>
      </div>
      {/* Instructions */}
      <div className="card-phone p-5">
        <p className="text-sm font-semibold text-foreground mb-3">What to do:</p>
        <div className="flex flex-col gap-3">
          {[
            { step: '1', text: 'Return to the staff &amp; faculty time clock tablet in the common area' },
            { step: '2', text: 'Wait for the current QR code to be displayed' },
            { step: '3', text: 'Scan the QR code with your phone camera' },
          ]?.map(item => (
            <div key={`step-${item?.step}`} className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-white text-xs font-bold">{item?.step}</span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{item?.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}